import api from "./config.js";

    // Obtener todas las mesas
    export const getMesas = async () => {
    const { data } = await api.get("/mesas");
    return Array.isArray(data) ? data : data.mesas || [];
    };

    // Obtener una mesa por ID
    export const getMesa = async (id) => {
    const { data } = await api.get(`/mesas/${id}`);
    return data;
    };

    // Crear mesa
    export const createMesa = async (mesa) => {
    const { data } = await api.post("/mesas", mesa);
    return data;
    };

    // Actualizar mesa
    export const updateMesa = async (id, mesa) => {
    const { data } = await api.put(`/mesas/${id}`, mesa);
    return data;
    };

    // Eliminar mesa
    export const deleteMesa = async (id) => {
    const { data } = await api.delete(`/mesas/${id}`);
    return data;
    };
